export default {
	auto: {
		label: 'Auto',
		value: 'auto',
		css: {
			skewX: 0,
		},
		displayIdx: 1
	},
	shift_left: {
		label: 'Shift Left',
		value: 'shift_left',
		css: {
			skewX: 10,
		},
		displayIdx: 2
	},
	shift_right: {
		label: 'Shift Right',
		value: 'shift_right',
		css: {
			skewX: -10,
		},
		displayIdx: 3
	}
}
